import { Row } from 'antd';
import styled from 'styled-components';

export const ActionBar = styled(Row)`
  justify-content: flex-end;
  margin-bottom: 18px;
`;

export const StyledContainer = styled.div`
  .ant-table-wrapper {
    margin-top: 0;
  }
`;
